import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";
import OneCustomScroll from "@/modules/module-oneCustomScroll";
import 'slick-carousel';

export default Backbone.View.extend({
  initialize: function (opts) {
    console.log("init article page");

    var self = this;
    self.$content = self.$el;
    self.$articleCrossSell = self.$content.find('.article-cross-sell');
    self.$products = self.$articleCrossSell.find('.product-grid-item');

    self.resizeTimeout;

    if (self.$articleCrossSell.length > 0) {
      OneCustomScroll.init({
        el: self.$articleCrossSell[0],
        margin: 0
      });
      self.handleSlickForProductCardImages();
    }

    $(window).resize(function () {
      clearTimeout(self.resizeTimeout);
      self.resizeTimeout = setTimeout(function () {
        self.handleSlickForProductCardImages();
      }, 100);
    });
  },

  events: {},

  handleSlickForProductCardImages: function () {
    console.debug('qq12 handleSlickForProductCardImages');
    var self = this;
    var $imagesWrapper = self.$products.find('.images-wrapper');

    // Check if slick is already initialized and unslick it
    $imagesWrapper.each(function(index, imagesWrapper) {
      if($(imagesWrapper).hasClass('slick-initialized')) {
          $(imagesWrapper).slick('unslick');
      }
    });

    if(ORW.responsive != 'small') return
    
    $imagesWrapper.slick({
      dots: true,
      arrows: false,
      infinite: false,
      slidesToShow: 1,
    })

    // Remove ".slideGesture" class from the first mobile product card when swiping
    $($imagesWrapper[0]).on('swipe', function(event, slick, direction){
      $(this).removeClass('slideGesture');
    });
},

  destroy: function () {
    var self = this;
    self.undelegateEvents();
  },

  responsive: function () {
    var self = this;
    ORW.utilities.mediaCheck(
      function () {
        // Desktop actions
      },
      function () {
        // Mobile actions
      }
    );
  },

  isMobile: function () {
    if (ORW.responsive == "small") {
      return true;
    }
    return false;
  },
});
